import React from 'react';
import { Link } from 'react-router-dom';
// import { ArrowRight } from 'lucide-react'; // Удален неиспользуемый импорт

// Импортируем общий массив категорий и универсальный компонент карточки
import { allCatalogCategories } from '../../constants/catalogCategories';
import CategoryCard from '../catalog/CategoryCard';

const ProductCategories: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Каталог электрооборудования</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Комплексные решения для энергоснабжения: от трансформаторов и КТП до кабельной продукции и блочно-модульных зданий
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Используем общий массив и компонент CategoryCard */}
          {allCatalogCategories.map(category => (
            <CategoryCard key={category.id} category={category} />
          ))}
        </div>
        
        <div className="text-center mt-12">
          <Link 
            to="/catalog" 
            className="btn-primary"
            aria-label="Перейти в полный каталог"
          >
            Полный каталог
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductCategories;